import React from 'react';
import { MessageSquareText } from 'lucide-react';

const LinkedInPostCommentPage: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-96">
      <div className="text-center">
        <div className="w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <MessageSquareText className="text-blue-600" size={48} />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Coming Soon...</h1>
        <p className="text-gray-600">LinkedIn Post & Comment Agent is under development</p>
      </div>
    </div>
  );
};

export default LinkedInPostCommentPage;